export type WorkstationSettingsData = {
  isMapWorkstationToRoomEnabled: boolean;
  roomId: number | null;
};

export const defaultWorkstationSettings: WorkstationSettingsData = {
  isMapWorkstationToRoomEnabled: false,
  roomId: null,
};

export enum WorkstationSettingsKeys {
  'WorkstationSettings' = 'workstationSettings',
}
